import { Type } from 'typebox';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const SdcAssessmentEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.sdcAssessment),
        assetCode: Type.String({ minLength: 1 }),
        childKey: Type.Optional(Type.String({ minLength: 1 })),
        actorKey: Type.Optional(Type.String({ minLength: 1 })),
        questionId: Type.Optional(Type.String({ minLength: 1 })),
        answer: Type.Optional(Type.String())
    })
]));
